var map = {
	"./giga-diamond.png": "9ad8",
	"./index.html": "2a19",
	"./master-diamond.png": "699a",
	"./master.png": "05f9",
	"./mega-diamond.png": "2382",
	"./power-diamond.png": "78c0",
	"./senior.png": "22df",
	"./start.png": "b85a",
	"./tera-diamond.png": "0d2e",
	"./thunder-diamond.png": "f006",
	"./ultra-diamond.png": "090d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5ee0";